import clsx from "clsx"
import { FC } from "react"
import { SpinnerCircular } from "spinners-react"
import { useLocation, useNavigate } from "react-router-dom"
import { useAppSelector } from "store/index"
import { AppSelectors } from "store/slices/appSlice"
import { useGetBalanceQuery } from "store/apis/balanceAPI/index"
import { useAnimatedNumber } from "hooks/useAnimatedNumber"
import spaceNumber from "utils/spaceNumber"
import { FittyText } from "ui/fitty-text"
import { bonesIcon, goldIcon, plusIcon, ton3dIcon } from "assets/icons"
import Container from "../container"
import "./index.scss"
import { tonBalancePaths } from "./data/ton-balance-path"

interface BalanceProps {
  isLowered?: boolean
}

const Balance: FC<BalanceProps> = ({ isLowered = false }) => {
  const navigate = useNavigate()
  const location = useLocation()

  const { data: balance, isFetching } = useGetBalanceQuery()
  const language = useAppSelector(AppSelectors.selectLanguage())
  const isUnder = useAppSelector(AppSelectors.selectIsUnder())

  const gold = useAnimatedNumber(balance?.gold, {
    duration: 0.5,
    fractionDigits: 0
  })

  const bones = useAnimatedNumber(balance?.bones, {
    duration: 0.5,
    fractionDigits: 0
  })

  const ton = useAnimatedNumber(balance?.ton, {
    duration: 0.5,
    fractionDigits: 2
  })

  return (
    <div id="balance" className={clsx({ lowered: isLowered })}>
      <Container
        className={`coin gold hover-effect ${language}`}
        triangleBottomPosLeft="93px"
        onClick={() => navigate("/wallet/buy-gold")}
      >
        <img src={goldIcon} alt="gold logo" width="24px" height="24px" />
        <div className={`coin-value`}>
          <FittyText maxSize={14} pos="center">
            {isFetching ? (
              <SpinnerCircular
                className="loading-spinner"
                size={14}
                thickness={250}
                color="#35262699"
              />
            ) : (
              spaceNumber(gold)
            )}
          </FittyText>
        </div>
        <img src={plusIcon} alt="purchase" className="purchase" />
      </Container>
      {isUnder || tonBalancePaths.includes(location.pathname) ? (
        <Container
          className={`coin ton hover-effect ${language}`}
          triangleTopPosLeft="50px"
          onClick={() => navigate("/wallet/deposit")}
        >
          <img src={ton3dIcon} alt="ton logo" width="24px" height="24px" />

          <div className={`coin-value`}>
            <FittyText maxSize={14} pos="center">
              {isFetching ? (
                <SpinnerCircular
                  className="loading-spinner"
                  size={14}
                  thickness={250}
                  color="#35262699"
                />
              ) : (
                spaceNumber(ton)
              )}
            </FittyText>
          </div>
          <img src={plusIcon} alt="deposit" className="purchase" />
        </Container>
      ) : (
        <Container
          className={`coin bones ${language}`}
          triangleTopPosLeft="50px"
        >
          <img src={bonesIcon} alt="bones logo" width="24px" height="24px" />

          <div className={`coin-value`}>
            <FittyText maxSize={14} pos="center">
              {isFetching ? (
                <SpinnerCircular
                  className="loading-spinner"
                  size={14}
                  thickness={250}
                  color="#35262699"
                />
              ) : (
                spaceNumber(bones)
              )}
            </FittyText>
          </div>
        </Container>
      )}
    </div>
  )
}

export default Balance
